module.exports = __webpack_public_path__ + "img/logo-rotate2.245effe7.png";